import Client from '@/clients/apiClient';

export default {
  getCityList() {
    return Client.get('cities');
  },
  getHouseTypeList() {
    return Client.get('house-types');
  },
  getDegreeList() {
    return Client.get('degree');
  },
  getJobTypeList() {
    return Client.get('job-types');
  },
  getJobPositionTypeList() {
    return Client.get('position-types');
  },
  getBankList() {
    return Client.get('banks');
  },
  getRelationshipTypeList() {
    return Client.get('relationship-types');
  },
};
